export function deepMerge<T>(target: Partial<T>, source: Partial<T>): T {
  const output = { ...target };
  for (const key in source) {
    if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
      output[key] = deepMerge((target[key] as any) || {}, source[key] as any);
    } else if (typeof source[key] !== 'undefined') {
      output[key] = source[key];
    }
  }
  return output as T;
}
